// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Services
import Ticket from 'services/data/ticket';

// Components
import TicketForm from 'components/models/ticket/forms/ticket-form';


class EditTicket extends React.Component {
  static propTypes = {
    close: PropTypes.func,
    closeOnSubmit: PropTypes.bool,
    onSubmit: PropTypes.func,
    initialValues: PropTypes.object.isRequired
  };

  constructor() {
    super();

    this.submit = this.submit.bind(this);
  }

  submit(values) {
    const { onSubmit, closeOnSubmit, close } = this.props;

    return Ticket.update(values)
      .then(savedTicket => {
        if (closeOnSubmit) close();
        if (onSubmit) return onSubmit(savedTicket);
      });
  }

  render() {
    const { initialValues, ticket, close } = this.props;
    return (
      <div className="edit-ticket">
        <TicketForm
          onSubmit={this.submit}
          initialValues={initialValues}
          close={close}
          ticket={ticket}
          form={`ticketForm-${initialValues.id}`}
        />
      </div>
    );
  }
}

export default connect(state => ({
  companies: state.pageData.selectCompanies
}))(EditTicket);
